<h2 mat-dialog-title>{{isFechaPlanif ? 'Fecha de Planificación Masiva' : 'Cambios Masivos'}}</h2>

<mat-label *ngIf="isLoading"><i class="fa fa-spinner fa-spin"></i> Cargando...</mat-label>
<div mat-dialog-content *ngIf="!isLoading">

  <form [formGroup]="formGroup" *ngIf="data.CanEditMaterial">

    <div fxLayout="column stretch" fxLayout.xs="column">

       <!-- Solo para Fecha de Planificación -->
       <div *ngIf="isFechaPlanif" fxFlex=50 fxFlex.xs=100 class="flex-item">
        <mat-form-field appearance="outline" style="width: 100%">
          <mat-label>Fecha de Planificación*</mat-label>
          <input matInput (dateChange)="checkToday()" [matDatepicker]="fechaEntregaPlanificadaPicker" formControlName="FechaEntregaPlanificada"
            (click)="fechaEntregaPlanificadaPicker.open()">
          <mat-datepicker-toggle style="display:inline-block;" matSuffix [for]="fechaEntregaPlanificadaPicker">
          </mat-datepicker-toggle>
          <mat-datepicker-toggle  style="display:inline-block;" matSuffix (click)="clearDate('FechaEntregaPlanificada')">
            <mat-icon matDatepickerToggleIcon>clear</mat-icon>
          </mat-datepicker-toggle>
          <mat-datepicker #fechaEntregaPlanificadaPicker></mat-datepicker>
          <mat-error
            *ngIf="!formGroup.controls['FechaEntregaPlanificada'].valid && formGroup.controls['FechaEntregaPlanificada'].touched">
            {{ getErrorFechaPlanificacion() }}
          </mat-error>
        </mat-form-field>
      </div>

     <!-- Para Cambios Masivos -->
    <ng-container *ngIf="!isFechaPlanif">
        <div fxFlex=50 fxFlex.xs=100 class="flex-item">
          <mat-form-field appearance="outline" style="width: 100%">
            <mat-label>Fecha Necesidad*</mat-label>
            <input matInput (dateChange)="checkToday()" [matDatepicker]="fechaNecesidadPicker" formControlName="FechaNecesidad"
              (click)="fechaNecesidadPicker.open()">
            <mat-datepicker-toggle style="display:inline-block;" matSuffix [for]="fechaNecesidadPicker">
            </mat-datepicker-toggle>
            <mat-datepicker-toggle  style="display:inline-block;" matSuffix (click)="clearDate('FechaNecesidad')">
              <mat-icon matDatepickerToggleIcon>clear</mat-icon>
            </mat-datepicker-toggle>
            <mat-datepicker #fechaNecesidadPicker></mat-datepicker>
            <mat-error
              *ngIf="!formGroup.controls['FechaNecesidad'].valid && formGroup.controls['FechaNecesidad'].touched">
              {{ getErrorFechaNecesidad() }}
            </mat-error>
          </mat-form-field>
        </div>
        <div fxFlex=50 fxFlex.xs=100 class="flex-item">
          <mat-form-field appearance="outline" style="width: 100%">
            <mat-label>Fecha Límite*</mat-label>
            <input matInput (dateChange)="checkDate()" [matDatepicker]="fechaLimitePicker" formControlName="FechaLimite"
              (click)="fechaLimitePicker.open()">
            <mat-datepicker-toggle style="display:inline-block;" matSuffix [for]="fechaLimitePicker">
            </mat-datepicker-toggle>
            <mat-datepicker-toggle style="display:inline-block;" matSuffix (click)="clearDate('FechaLimite')">
              <mat-icon matDatepickerToggleIcon>clear</mat-icon>
            </mat-datepicker-toggle>
            <mat-datepicker #fechaLimitePicker></mat-datepicker>
            <mat-error
              *ngIf="!formGroup.controls['FechaLimite'].valid && formGroup.controls['FechaLimite'].touched">
              {{ getErrorFechaLimite() }}
            </mat-error>
          </mat-form-field>
        </div>
      </ng-container>
    </div>
  </form>


</div>

<br />

<div mat-dialog-actions>
  <div fxLayout="row stretch" fxLayout.xs="column">
    <button mat-raised-button color="primary" (click)="onGuardar()" class="zb-button" *ngIf="data?.CanEditMaterial">Guardar</button>
    <button mat-raised-button color="warn" (click)="onDecline()" class="zb-button">Cancelar</button>
  </div>
</div>

<!-- <div mat-dialog-actions>
  <div fxLayout="row stretch" fxLayout.xs="column">
    <button mat-raised-button color="primary" (click)="onGuardar()" class="zb-button" >Guardar</button>
    <button mat-raised-button color="warn" (click)="onDecline()" class="zb-button">Cancelar</button>
  </div>
</div> -->
